// Alive Water - links from the ZIP gate to the "Where we deliver" page (snippets/aw-zip-gate-links.liquid).
//
// Deliberately a SEPARATE script: aw-zip-gate.js (verdicts, cart attributes, the aw_delivery handoff, the
// Klaviyo waitlist call) is not modified. This file only listens to the gate's own "aw:eligibility" event and
// adds one link under the gate's result:
//   served or surcharge  -> "<areas page>?zip=NNNNN" (the page checks that ZIP on load)
//   waitlist             -> "<areas page>"
// It reads nothing from the network and writes nothing anywhere.
const holder = document.getElementById('aw-zip-gate-links');
const gate = document.getElementById('aw-zip-gate');
const result = document.getElementById('aw-zip-result');

// The bold first-delivery line (2026-10-16). Routes that run every 3 weeks or more get the next-run wording,
// because a 1 to 2 week promise is wrong there.
export function estimateFor(res, plain, route) {
  if (!res || !(res.state === 'served' || res.state === 'surcharge')) return null;
  const weeks = res.cadence && Number(res.cadence.weeks);
  if (weeks >= 3 && route) return route.replace('[weeks]', String(weeks));
  return plain || null;
}

export function linkFor(res, base, origin) {
  if (!res || !res.zip) return null;
  const u = new URL(base || '/pages/delivery-areas', origin || 'https://alivewaters.com');
  if (res.state === 'waitlist') return { kind: 'waitlist', href: u.pathname + u.search };
  if (res.state === 'served' || res.state === 'surcharge') { u.searchParams.set('zip', res.zip); return { kind: 'served', href: u.pathname + u.search }; }
  return null;
}

if (holder && gate && result) {
  const where = (gate.dataset.gateLocation || 'order');
  const allowed = (holder.dataset.locations || 'home,order').split(',').map(s => s.trim());
  if (allowed.indexOf(where) > -1) {
    let node = null, est = null;
    const clear = () => { if (node) { node.remove(); node = null; } if (est) { est.remove(); est = null; } };
    const place = (res) => {
      clear();
      if (!res || result.hidden) return;
      const estText = estimateFor(res, holder.dataset.estimateText, holder.dataset.estimateRouteText);
      if (estText) {
        est = document.createElement('p');
        est.className = 'aw-gate__estimate';
        const b = document.createElement('strong');
        b.textContent = estText;
        est.append(b);
        result.insertAdjacentElement('afterend', est);
      }
      const l = linkFor(res, holder.dataset.areasUrl, location.origin);
      if (!l) return;
      const text = l.kind === 'waitlist' ? holder.dataset.waitlistText : holder.dataset.servedText;
      if (!text) return;
      node = document.createElement('p');
      node.className = 'aw-gate__areas';
      const a = document.createElement('a');
      a.href = l.href;
      a.textContent = text;
      a.className = 'js-no-transition';
      a.addEventListener('click', () => {
        const payload = { event: 'zip_gate_areas_link', gate: 'zip', location: where, result: l.kind };
        try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
      });
      node.append(a);
      // after the last visible gate control, so the gate's own CTA and waitlist keep their place
      const after = l.kind === 'waitlist' ? document.getElementById('aw-zip-waitlist') : document.getElementById('aw-zip-cta');
      const anchor = after && !after.hidden ? after : result;
      anchor.insertAdjacentElement('afterend', node);
    };
    document.addEventListener('aw:eligibility', e => place(e.detail));
    // a new submit or "Change ZIP" starts over (the gate's invalid-ZIP path fires no event). Capture phase on
    // the document, so this runs BEFORE the gate's own submit handler: microtasks run between listeners of a
    // native event, so a later listener would wipe the link the gate's handler had just caused.
    const form = document.getElementById('aw-zip-form');
    if (form) document.addEventListener('submit', e => { if (e.target === form) clear(); }, true);
    new MutationObserver(() => { if (result.hidden) clear(); }).observe(result, { attributes: true, attributeFilter: ['hidden'] });
  }
}
